import api from '@/services/api';

const API_BASE = '/customer/profile';

export interface ProfileUpdateData {
  first_name: string;
  last_name: string;
  email: string;
  mobile?: string;
  house_no?: string;
  street?: string;
  barangay?: string;
  city?: string;
}

export interface ProfileResponse {
  success: boolean;
  message: string;
  data?: any;
}

export const customerProfileService = {
  /**
   * Update customer profile
   */
  async updateProfile(data: ProfileUpdateData): Promise<ProfileResponse> {
    const response = await api.put(API_BASE, data);
    return response.data;
  }
};

